// Helper function to convert Excel's decimal time to "HH:MM" string
export const convertExcelTime = (excelTime) => {
    if (excelTime === "Closed" || typeof excelTime !== 'number') {
        return excelTime; // Return "Closed" or non-numeric values as is
    }

    const hours = Math.floor(excelTime * 24);
    const minutes = Math.round((excelTime * 24 - hours) * 60);

    // Format with leading zeros
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
};

//Helper function to convert Excel's string/number to Date object
export const convertExcelDate = (excelDate) => {
  let date;

  // Check if it's already a string date that JavaScript can parse
  if (typeof excelDate === 'string' && !isNaN(new Date(excelDate))) {
    date = new Date(excelDate);
  } else if (typeof excelDate === 'number') {
    // Excel's 1900 date system: Day 1 is Jan 1, 1900.
    // Excel incorrectly treats 1900 as a leap year, so Jan 1, 1900 is effectively day 2.
    // We adjust the epoch to Dec 30, 1899 UTC to account for this and align with standard JS Date.
    const excelEpoch = new Date(Date.UTC(1899, 11, 30)); // Dec 30, 1899 UTC
    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    date = new Date(excelEpoch.getTime() + (excelDate * millisecondsPerDay));
  } else {
    console.warn("convertExcelDate received an unparseable date input:", excelDate);
    return null;
  }

  // If the date is invalid (e.g., excelDate was unparseable or a bad serial number)
  if (isNaN(date.getTime())) {
    console.warn("Invalid date conversion for input:", excelDate);
    return null;
  }

  // Format the date to YYYY-MM-DD
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

// Helper Function to get the current date in MM/DD/YYYY format
export const getFormattedCurrentDateYYYYMMDD = () => {
  const today = new Date();

  // Get year, month, and day components
  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed, so add 1. padStart ensures 2 digits.
  const day = today.getDate().toString().padStart(2, '0');        // padStart ensures 2 digits.

  // Concatenate them in the desired format
  return `${year}-${month}-${day}`;
};